var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinBagLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.533,
    height: 26.008,
    viewBox: "0 0 26.533 26.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin-bag-line",
    transform: "translate(-2.054 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M20.1,28.813A.813.813,0,0,0,19.289,28H14.413a.813.813,0,1,0,0,1.625h4.876A.813.813,0,0,0,20.1,28.813Z",
    transform: "translate(-2.162 -4.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M21.229,24H16.353a.813.813,0,0,0,0,1.625h4.876a.813.813,0,1,0,0-1.625Z",
    transform: "translate(-2.525 -4.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M20.689,32H15.813a.813.813,0,0,0,0,1.625h4.876a.813.813,0,0,0,0-1.625Z",
    transform: "translate(-2.424 -5.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M31.2,32H25.513a.813.813,0,0,0,0,1.625H31.2A.813.813,0,0,0,31.2,32Z",
    transform: "translate(-4.241 -5.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M32.2,28H26.513a.813.813,0,0,0,0,1.625H32.2A.813.813,0,0,0,32.2,28Z",
    transform: "translate(-4.428 -4.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M27.807,21.506a22.757,22.757,0,0,0-2.292-8.225,16.45,16.45,0,0,0-5.137-5.827l1.951-4.3A.8.8,0,0,0,21.622,2H8.349a.813.813,0,0,0-.74,1.154L9.6,7.47a16.523,16.523,0,0,0-5.1,5.811,24.648,24.648,0,0,0-2.438,9.981,2.926,2.926,0,0,0,.813,2.2,3.08,3.08,0,0,0,2.227.87h5.039V24.757h-5.1a1.365,1.365,0,0,1-.983-.423,1.317,1.317,0,0,1-.366-1,23.746,23.746,0,0,1,2.243-9.306A14.629,14.629,0,0,1,11.015,8.5h.813a25.04,25.04,0,0,0-1.52,2.373A18.514,18.514,0,0,0,9.113,13.59l1.113.748a19.506,19.506,0,0,1,1.211-2.82A23.651,23.651,0,0,1,13.429,8.5h.813a17.433,17.433,0,0,1,1.146,4.064,18.319,18.319,0,0,1,.26,3.137l1.284-.9a19.628,19.628,0,0,0-.26-2.438A20.172,20.172,0,0,0,15.632,8.5h.634l.74-1.625H11.121l-1.5-3.251H20.354L18.322,8.071a8.071,8.071,0,0,1,1,.634,15.141,15.141,0,0,1,4.763,5.34,21.611,21.611,0,0,1,2.089,7.461Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBagLine);
export default __webpack_public_path__ + "static/media/coin-bag-line.e0ddf288ea28eb41c40685378e8ae585.svg";
export { ForwardRef as ReactComponent };